export default __webpack_public_path__ + "static/media/example_img_1_6_1.67d50223.png";